import { useLocation } from "react-router";
import { NAV_LINKS } from "../../utils/nav-links";
import PlotsArrangement from "../../components/PlotsArrangement/indext";
import PlotFrame from "../../components/PlotFrame";
import styles from "./styles.module.css";
import { App2TestingTimelineDescription } from "../../utils/plot-descriptions";
import TimelinePlot from "../../plots/components/App2Testing/TimelinePlot";

export default function SensorsDashboardAnalyticsPage() {
    const location = useLocation();

    return <div className={styles.container}>
        <h4 className={styles.title}>
            {NAV_LINKS.filter((link) => link.href === location.pathname)[0].title}{" "}
        </h4>
        <PlotsArrangement>
            <PlotFrame title="User Journey" plotDescription={App2TestingTimelineDescription}>
                <TimelinePlot />
            </PlotFrame>
        </PlotsArrangement>
    </div>
}
